"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BL_ORDER_DATE_KEYS = exports.BL_ORDER_NON_EDITABLE_KEYS = exports.BL_ORDER_METYCLE_KEY_PREFIX = void 0;
exports.isEditableTemplateKey = isEditableTemplateKey;
const bl_order_variable_namespace_1 = require("./bl-order-variable-namespace");
exports.BL_ORDER_METYCLE_KEY_PREFIX = 'metycle_';
// Render-context keys that are computed text helpers (assembled from other
// fields), not operator-editable inputs. Derived from the `computed` group of
// `BL_ORDER_VARIABLE_NAMESPACE` so adding a new computed line only requires
// updating the namespace.
exports.BL_ORDER_NON_EDITABLE_KEYS = new Set(bl_order_variable_namespace_1.BL_ORDER_VARIABLE_NAMESPACE.computed.variables.map((v) => v.path));
// Render-context keys whose value is `Date | null` in `BLOrderRenderContext`.
// Excluded from the editable input because the renderer expects real `Date`
// objects (a PATCH carrying `"2026-04-15"` would be a string the formatter
// can't handle). Dates render from the freshly-rebuilt context on regenerate.
//
// Hand-rolled — `BL_ORDER_VARIABLE_NAMESPACE` does not carry value types. Keep
// in sync with the `Date | null` fields of `BLOrderRenderContext` in
// `backend/src/features/documents/templates/bl-order-preview-fixture.ts`.
exports.BL_ORDER_DATE_KEYS = new Set([
    'current_date',
    'bl_issue_date',
    'onboard_date',
    'etd',
    'eta',
    'atd',
    'ata',
    'initial_eta',
    'eta_final_destination',
    'ata_final_destination',
    'ata_customer',
    'booking_date',
    'loading_date',
    'customs_clearance',
    'bl_release_date',
    'bl_confirmed_date',
    'documents_sent_date',
    'sold_date',
    'sorting_at_buyers_factory',
    'sell_fixed_date',
    'buy_fixed_date',
    'downpayment_original_due_date',
    'downpayment_actual_due_date',
    'latest_repayment_date',
]);
// True when a key is allowed to appear in `template_input` and `field_overrides`:
// not the Metycle letterhead block, not a computed helper line, not a Date field.
function isEditableTemplateKey(key) {
    return (!key.startsWith(exports.BL_ORDER_METYCLE_KEY_PREFIX) &&
        !exports.BL_ORDER_NON_EDITABLE_KEYS.has(key) &&
        !exports.BL_ORDER_DATE_KEYS.has(key));
}
//# sourceMappingURL=template-input.js.map